export default (state, action) => {
    switch (action.type){
        case "preferredLanguage":
            return {
                ...state, preferredLanguage: action.payload
            };
        default:
            return state;
    }
};